// =============================================================================
// state
// =============================================================================
const state = {
  holidays: [],
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  holidays: state => state.holidays,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_holidays: (state, value) => { state.holidays = value; },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
